import React from 'react';

import Actions from './Actions';

export default (affiliateId) => {
  let columns = [
    {
      name: 'Enterprise',
      selector: (row) => row.attributes.company,
      sortable: true,
      width: affiliateId == null ? '150px' : '250px',
    },
    {
      name: 'Date',
      selector: (row) => row.attributes.added_date,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Contact',
      selector: (row) => row.attributes.contact,
      sortable: true,
      width: affiliateId == null ? '150px' : '250px',
    },
    {
      name: 'Email',
      selector: (row) => row.attributes.email,
      sortable: true,
      width: '200px',
    },
    {
      name: 'Website',
      selector: (row) => row.attributes.website,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Action',
      sortable: false,
      cell: (row) => <Actions row={row} />,
      width: '100px',
    },
  ];
  if (affiliateId == null) {
    columns = [{
      name: 'Affiliate',
      selector: (row) => row.attributes.affiliate_name,
      sortable: true,
      width: '200px',
    }, ...columns];
  }
  return columns;
};
